import {ShapeCommand} from '../commands.template';
import * as _ from 'lodash';
import {getActivityMinWH} from '../../diagram-render/styles/styles.util';
declare let mxUtils: any;

export class ActivityDeleteAttributeCommand extends ShapeCommand {
  services: any;
  firstAction: boolean;
  mxKey: number;
  reverseData: any;
  constructor(data) {
    super(data);
    this.firstAction = true;
  }

  public prepareData() {
    const activityJson = this.services.jsonHandlerSvc.get().activities.find(a => {
      return Number(a.mxKey) === Number(this.object.activityMxKey);
    });
    const index = _.findIndex(activityJson.attributes, (att: any) => {
      return Number(att.mxKey) === Number(this.object.mxKey);
    });
    const attribute = activityJson.attributes[index];

    this.reverseData = {
      activityMxKey: this.object.activityMxKey,
      mxKey: attribute.mxKey,
      text: attribute.text,
      position: index
    };

    return this;
  }

  public execute() {
    super.execute();
    const action = {
      deleteAttribute: {
        activityMxKey: Number(this.object.activityMxKey),
        mxKey: this.object.mxKey
      }
    };

    this.applyGraphChanges(false);
    this.services.diagramUpdateSvc.update(action);
    this.redrawActivity(this.object.activityMxKey);
  }

  public reverse() {
    super.reverse();
    const action = {
      addAttribute: {
        activityMxKey: Number(this.object.activityMxKey),
        mxKey: this.reverseData.mxKey,
        text: this.reverseData.text,
        position: this.reverseData.position
      }
    };

    this.applyGraphChanges(true);
    this.services.diagramUpdateSvc.update(action);
    this.redrawActivity(this.object.activityMxKey);
  }

  private applyGraphChanges(add) {
    const dy = add ? 26 : -26;
    const graph = this.services.editorRegistrySvc.getGraph();
    const cell = graph.model.getCell(this.object.activityMxKey);
    const geo = cell.geometry.clone();
    const {minHeight} = getActivityMinWH(
      cell.getJson(),
      this.services.diagramTypeConfigService.currentType()
    );

    graph.getModel().beginUpdate();
    cell.skipUndo = true;
    graph.getModel().setStyle(cell, mxUtils.setStyle(cell.style, 'minHeight', minHeight + dy));
    graph.getModel().setGeometry(cell, geo);
    graph.getModel().endUpdate();
  }

  private redrawActivity(activityMxKey) {
    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(Number(activityMxKey))
      .comp.instance.setupFromJson();
  }
}
